//Author June Leow
//Date Mar 22nd, 2024
import {generateTooltip} from '../../../../util/util';
import {Col, Row, Input} from 'reactstrap';
import MySelect from '../../../util/my-select';
import React, {useEffect} from 'react';


const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


const Ancillary  = (props)=>{
  const controller = new AbortController();

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const updateAncillary = (parent, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    if(parent===''){
      newUPD.property.ancillary[field] = value;
    }
    else{
      newUPD.property.ancillary[parent][field] = value;
    }

    props.update(newUPD);
  }
  //API call

  //render
  let ancillary = Object.assign({}, props.upd).property.ancillary;
  return <div>
    <label>Road Description {generateTooltip('roadDesc', 'A free-form text field used to describe the property off-site improvement specified by Property Off Site Improvement Feature Type.')}</label>
    <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.roadDesc} onChange={(e)=>updateAncillary('','roadDesc', e.target.value)}/>
    <br/>
    <Row>
      <Col sm="6">
        <label>Attic Floor Exists {generateTooltip('atticFloorExists', 'Indicates if the feature specified in Attic Feature Type is present in the structure.')}</label>
        <MySelect
          type="select"
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={ancillary.atticFloorExists}
          onChange={(v)=>updateAncillary('', 'atticFloorExists', v)}
          options={[{label:'', value:''},{label:"True", value:"True"}, {label:"False", value:"False"}]}
        />
      </Col>
      <Col sm="6">
        <label>Heated Attic {generateTooltip('atticHeated', 'Indicates if the feature specified in Attic Feature Type is present in the structure.')}</label>
        <MySelect
          type="select"
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={ancillary.atticHeated}
          onChange={(v)=>updateAncillary('', 'atticHeated', v)}
          options={[{label:'', value:''},{label:"True", value:"True"}, {label:"False", value:"False"}]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm="6">
        <label>Heating Fuel Description {generateTooltip('heatingFuelDesc', 'A free-form text field used to describe the fuel used by the heating unit.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.heatingFuelDesc} onChange={(e)=>updateAncillary('','heatingFuelDesc', e.target.value)}/>
      </Col>
      <Col sm="6">
        <label>Driveway Surface Description {generateTooltip('drivewaySurfaceDesc', 'A free-form text field used to describe or comment on the aspect of the property named in the Site Feature Type.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.drivewaySurfaceDesc} onChange={(e)=>updateAncillary('','drivewaySurfaceDesc', e.target.value)}/>
      </Col>
    </Row>
    <label>Alley Description {generateTooltip('desc', 'A free-form text field used to describe the property off-site improvement specified by Property Off Site Improvement Feature Type.')}</label>
    <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.alley.desc} onChange={(e)=>updateAncillary('alley','desc', e.target.value)}/>
    <Row>
      <Col sm="6">
        <label>Alley Public {generateTooltip('public', 'Indicates that the particular off-site improvement feature specified by Property Off Site Improvement Feature Type is present.')}</label>
        <MySelect
          type="select"
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={ancillary.alley.public}
          onChange={(v)=>updateAncillary('alley', 'public', v)}
          options={[{label:'', value:''},{label:"True", value:"True"}, {label:"False", value:"False"}]}
        />
      </Col>
      <Col sm="6">
        <label>Alley Private {generateTooltip('private', 'Indicates that the particular off-site improvement feature specified by Property Off Site Improvement Feature Type is present.')}</label>
        <MySelect
          type="select"
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={ancillary.alley.private}
          onChange={(v)=>updateAncillary('alley', 'private', v)}
          options={[{label:'', value:''},{label:"True", value:"True"}, {label:"False", value:"False"}]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm="6">
        <label>Refrigerator Exists {generateTooltip('refrigeratorExists', 'Indicates if the kitchen equipment specified in Kitchen Equipment Type is present in the unit.')}</label>
        <MySelect
          type="select"
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={ancillary.appliances.refrigeratorExists}
          onChange={(v)=>updateAncillary('appliances', 'refrigeratorExists', v)}
          options={[{label:'', value:''},{label:"True", value:"True"}, {label:"False", value:"False"}]}
        />
      </Col>
      <Col sm="6">
        <label>Dishwasher Exists {generateTooltip('dishwasherExists', 'Indicates if the kitchen equipment specified in Kitchen Equipment Type is present in the unit.')}</label>
        <MySelect
          type="select"
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={ancillary.appliances.dishwasherExists}
          onChange={(v)=>updateAncillary('appliances', 'dishwasherExists', v)}
          options={[{label:'', value:''},{label:"True", value:"True"}, {label:"False", value:"False"}]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm="6">
        <label>Garbage Disposal Exists {generateTooltip('disposalExists', 'Indicates if the kitchen equipment specified in Kitchen Equipment Type is present in the unit.')}</label>
        <MySelect
          type="select"
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={ancillary.appliances.disposalExists}
          onChange={(v)=>updateAncillary('appliances', 'disposalExists', v)}
          options={[{label:'', value:''},{label:"True", value:"True"}, {label:"False", value:"False"}]}
        />
      </Col>
      <Col sm="6">
        <label>Microwave Exists {generateTooltip('microwaveExists', 'Indicates if the kitchen equipment specified in Kitchen Equipment Type is present in the unit.')}</label>
        <MySelect
          type="select"
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={ancillary.appliances.microwaveExists}
          onChange={(v)=>updateAncillary('appliances', 'microwaveExists', v)}
          options={[{label:'', value:''},{label:"True", value:"True"}, {label:"False", value:"False"}]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm="6">
        <label>Washer/Dryer Exists {generateTooltip('washerDryerExists', 'Indicates if the kitchen equipment specified in Kitchen Equipment Type is present in the unit.')}</label>
        <MySelect
          type="select"
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={ancillary.appliances.washerDryerExists}
          onChange={(v)=>updateAncillary('appliances', 'washerDryerExists', v)}
          options={[{label:'', value:''},{label:"True", value:"True"}, {label:"False", value:"False"}]}
        />
      </Col>
      <Col sm="6">
        <label>Other Appliances Exist {generateTooltip('otherExists', 'Indicates if the kitchen equipment specified in Kitchen Equipment Type is present in the unit.')}</label>
        <MySelect
          type="select"
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={ancillary.appliances.otherExists}
          onChange={(v)=>updateAncillary('appliances', 'otherExists', v)}
          options={[{label:'', value:''},{label:"True", value:"True"}, {label:"False", value:"False"}]}
        />
      </Col>
    </Row>
    
    <br/>

    <Row>
      <Col sm="6">
        <label>Other Appliances Description {generateTooltip('otherDesc', 'A free-form text field used to describe the kitchen equipment if Other is selected as the Kitchen Equipment Type.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.appliances.otherDesc} onChange={(e)=>updateAncillary('appliances','otherDesc', e.target.value)}/>
      </Col>
      <Col sm="6">
        <label>Bathroom Wainscot Description {generateTooltip('bathWainscotDesc', 'A free-form text field used to describe the material used and condition of an interior feature specified by Interior Feature Type.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.interior.bathWainscotDesc} onChange={(e)=>updateAncillary('interior','bathWainscotDesc', e.target.value)}/>
      </Col>
    </Row>
    
    <Row>
      <Col sm="6">
        <label>Foundations Walls Description {generateTooltip('descFoundationWalls', 'A free-form text field used to describe the exterior feature.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.exterior.descFoundationWalls} onChange={(e)=>updateAncillary('exterior','descFoundationWalls', e.target.value)}/>
      </Col>
      <Col sm="6">
        <label>Exterior Walls Description {generateTooltip('descExtWalls', 'A free-form text field used to describe the exterior feature.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.exterior.descExtWalls} onChange={(e)=>updateAncillary('exterior','descExtWalls', e.target.value)}/>
      </Col>
    </Row>

    <Row>
      <Col sm="6">
        <label>Description of Roof Surface {generateTooltip('descRoofSurface', 'A free-form text field used to describe the exterior feature.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.exterior.descRoofSurface} onChange={(e)=>updateAncillary('exterior','descRoofSurface', e.target.value)}/>
      </Col>
      <Col sm="6">
        <label>Gutters and Downspouts Description {generateTooltip('descGuttersDownspouts', 'A free-form text field used to describe the exterior feature.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.exterior.descGuttersDownspouts} onChange={(e)=>updateAncillary('exterior','descGuttersDownspouts', e.target.value)}/>
      </Col>
    </Row>

    <Row>
      <Col sm="6">
        <label>Window Type Description {generateTooltip('descWindowType', 'A free-form text field used to describe the exterior feature.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.exterior.descWindowType} onChange={(e)=>updateAncillary('exterior','descWindowType', e.target.value)}/>
      </Col>
      <Col sm="6">
        <label>Description of Insulated Storm Sash {generateTooltip('descStormSashInsulated', 'A free-form text field used to describe the exterior feature.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.exterior.descStormSashInsulated} onChange={(e)=>updateAncillary('exterior','descStormSashInsulated', e.target.value)}/>
      </Col>
    </Row>

    <Row>
      <Col sm="6">
        <label>Description of Window Screens {generateTooltip('descScreens', 'A free-form text field used to describe the exterior feature.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.exterior.descScreens} onChange={(e)=>updateAncillary('exterior','descScreens', e.target.value)}/>
      </Col>
      <Col sm="6">
        <label>Utilities Gas Other Description {generateTooltip('otherDesc', 'A free-form text field used to describe the ownership of the utility specified by Site Utility Type if it is a non-public utility.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.gas.otherDesc} onChange={(e)=>updateAncillary('gas','otherDesc', e.target.value)}/>
      </Col>
    </Row>

    <Row>
      <Col sm="6">
        <label>Interior Floors Description {generateTooltip('floorsDesc', 'A free-form text field used to describe the material used and condition of an interior feature specified by Interior Feature Type.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.interior.floorsDesc} onChange={(e)=>updateAncillary('interior','floorsDesc', e.target.value)}/>
      </Col>
      <Col sm="6">
        <label>Interior Walls Description {generateTooltip('wallsDesc', 'A free-form text field used to describe the material used and condition of an interior feature specified by Interior Feature Type.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.interior.wallsDesc} onChange={(e)=>updateAncillary('interior','wallsDesc', e.target.value)}/>
      </Col>
    </Row>

    <Row>
      <Col sm="6">
        <label>Interior Trim Description {generateTooltip('trimFinishDesc', 'A free-form text field used to describe the material used and condition of an interior feature specified by Interior Feature Type.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.interior.trimFinishDesc} onChange={(e)=>updateAncillary('interior','trimFinishDesc', e.target.value)}/>
      </Col>
      <Col sm="6">
        <label>Bathroom Floor Description {generateTooltip('bathFloorDesc', 'A free-form text field used to describe the material used and condition of an interior feature specified by Interior Feature Type.')}</label>
        <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={ancillary.interior.bathFloorDesc} onChange={(e)=>updateAncillary('interior','bathFloorDesc', e.target.value)}/>
      </Col>
    </Row>
  </div> 
}


export default Ancillary;